<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <div class="main borderShadow">
      <div class="top">账号下可用卡</div>
      <div class="bottom" v-if="chooseType == 0">
        <div
          @click="chooseCard(item)"
          class="item hands"
          v-for="(item, index) of currentPageInfo"
          :key="index"
        >
          {{ item.card_number }}
        </div>
      </div>
      <div class="bottom" v-if="chooseType == 1">
        <div
          @click="chooseCard2(item)"
          class="item hands"
          v-for="(item, index) of currentPageInfo"
          :key="index"
        >
          {{ item.card_number }}
        </div>
      </div>
      <div class="close hands c-animation" @click="$router.go(-1)">返回</div>
    </div>
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  orderFindRequest2,
  choosePhoneHaveCards,
  getPhoneHaveCardsInfo,
  cardCustomizedInfoRequest,
} from "../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      sysId: "", // 1.1.sysId应用ID
      currentPageInfo: {}, // 1.2.当前页面数据
      userInfo: {}, // 1.3.userInfo
      chooseType: 0, // 1.4.0礼品兑换的卡号选择，1订单查询的卡号选择
      card_customized_id: "", //定制页id
    };
  },

  methods: {
    // 2.methods
    getCardsInfo() {
      // 2.1.获取卡信息
      let data = {
        pageNo: -1,
        pageSize: -1,
        sysId: this.sysId,
      };

      getPhoneHaveCardsInfo(data).then((res) => {
        this.currentPageInfo = res.rows;
        if (this.currentPageInfo.length == 1) {
          this.chooseCard(this.currentPageInfo[0]);
        }
      });
    },

    chooseCard(item) {
      // 2.2.礼品兑换点击卡
      let data = {
        sysId: this.sysId,
        cardBindPhoneId: item.card_bind_phone_id,
      };

      choosePhoneHaveCards(data).then((res) => {
        if (res) {
          let obj = res.data[0];
          obj.token = this.token;
          this.card_customized_id = obj.card_customized_id;
          if (this.card_customized_id) {
            this.getCardCustomizedInfo(obj);
          } else {
            this.$router.push(
              "/goodsList?obj=" + encodeURIComponent(JSON.stringify(obj))
            );
          }
        }
      });
    },

    chooseCard2(item) {
      // 2.3.订单查询点击卡
      let data = {
        cardBindPhoneId: item.card_bind_phone_id,
        sysId: this.sysId,
        is1: 1,
      };

      orderFindRequest2(data).then((res) => {
        if (res) {
          this.$router.push(
            "/orderDetail?obj=" + encodeURIComponent(JSON.stringify(res.data))
          );
        }
      });
    },
    getCardCustomizedInfo(obj) {
      // 获取定制页信息
      let data = {
        cardCustomizedId: this.card_customized_id,
        sysId: this.sysId,
      };

      cardCustomizedInfoRequest(data).then((res) => {
        if (res) {
          let r = res.data[0];
          localStorage.web_order_success = r.web_order_success;
          localStorage.web_order_success_2 = r.web_order_success_2;
          localStorage.web_top_imgurl = r.web_top_imgurl;
          localStorage.web_top_linkurl = r.web_top_linkurl;
          localStorage.phone_top_imgurl = r.phone_top_imgurl;
          localStorage.phone_top_linkurl = r.phone_top_linkurl;
          localStorage.phone_convert_instructions =
            r.phone_convert_instructions;
          localStorage.web_rolling_notice = r.web_rolling_notice;

          this.$router.push(
            "/goodsList?obj=" + encodeURIComponent(JSON.stringify(obj))
          );
        }
      });
    },
  },

  mounted() {
    // 3.mounted
    if (this.$route.query.parse) {
      this.chooseType = this.$route.query.parse || 0;
    }

    if (this.$route.query.obj) {
      this.userInfo = JSON.parse(decodeURIComponent(this.$route.query.obj));
      this.sysId = JSON.parse(decodeURIComponent(this.$route.query.obj)).sysId;
      this.token = JSON.parse(decodeURIComponent(this.$route.query.obj)).token;
      this.card_customized_id = JSON.parse(
        decodeURIComponent(this.$route.query.obj)
      ).card_customized_id;
      this.getCardsInfo();
    }
  },
};
</script>

<style scoped lang="scss">
@import "./chooseCards.scss";
</style>